import {
  ArrayField,
  AutocompleteArrayInput,
  AutocompleteInput,
  BooleanInput,
  Button,
  ChipField,
  Datagrid,
  Edit,
  Filter,
  List,
  NumberInput,
  ReferenceArrayInput,
  ReferenceField,
  ReferenceInput,
  Show,
  SimpleForm,
  SingleFieldList,
  Tab,
  TabbedShowLayout,
  TextField,
  TextInput,
  TopToolbar,
  useShowContext,
  useNotify,
  useRefresh,
  useRecordContext,
  useGetOne,
} from "react-admin";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { useEffect, useState } from "react";
import { gql, useMutation as apolloUseMutation } from "@apollo/react-hooks";
import { useForm, useFormState, Form } from "react-final-form";
import { analyticsTrackEvent } from "../utils/segment";

//filters={DescriptionFilters}
//   id: Int!
//   project: Project!
//   payer: Company!
//   paidFor: Company!
//   created_at: Date
//   updated_at: Date

//   id: Int
//   ids: [Int]
//   payerCompany_id: Int
//   project_id: Int
//   paidForCompany_id: Int
//   created_at: String
//   created_at__like: String
//   updated_at: String
//   updated_at__like: String

const nameLikeSearch = (n) => {
  if (n && n.length >= 2) {
    return {
      name__like: n,
    }
  }
}

const companySearch = (n) => {
  if (n && n.length > 2) {
    return {
      name__like: n,
    };
  }
};

const CompanyProjectFilters = [
  <NumberInput label="id" source="id"/>,
  <BooleanInput label="Paying For Themselves" source="isPayingForThemselves" defaultValue={true}/>,
  <ReferenceInput label="Project" source="projectId" reference="Project" filterToQuery={nameLikeSearch} alwaysOn>
    <AutocompleteInput source="name"/>
  </ReferenceInput>,
  <ReferenceInput label="Payer Company" source="payerCompanyId" reference="Company" filterToQuery={nameLikeSearch} alwaysOn>
    <AutocompleteInput source="name"/>
  </ReferenceInput>,
  <ReferenceInput label="Paid For Company" source="paidForCompanyId" reference="Company" filterToQuery={nameLikeSearch} alwaysOn>
    <AutocompleteInput source="name"/>
  </ReferenceInput>,
];

export const CompanyProjectPayerList = (props) => (
  <List {...props} filters={CompanyProjectFilters} bulkActionButtons={false}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <ReferenceField label="Project" source="project.id" reference='Project' sortable={false} link="show">
        <TextField source="name"/>
      </ReferenceField>
      <ReferenceField label="Payer" reference="Company" source="payer.id" link="show" sortable={false}>
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField  label="Paid for" reference="Company" source="paidFor.id" link="show" sortable={false}>
        <TextField source="name" />
      </ReferenceField>
      <TextField source="created_at"/>
      <TextField source="updated_at"/>
    </Datagrid>
  </List>
);

const UpdatePayer = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const { data: paidForCompany, loaded } = useGetOne('Company', record?.paidFor.id );

  const [open, setOpen] = useState(false);
  const [company, setCompany] = useState();

  const [updateCompanyProjectPayer] = apolloUseMutation(gql`
    mutation updateCompanyProjectPayer($id: Int!, $payer_company_id: Int!) {
      updateCompanyProjectPayer(id: $id, updateCompanyProjectPayerInput: {payerCompanyId: $payer_company_id}) {
        id
      }
    }
  `);

  const handleClick = () => setOpen(true);
  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleEnable = async (args) => {
    try {
      const companyId = company.id;
      const payingCompanyName = company.name;
      await updateCompanyProjectPayer({ variables: { id: record.id, payer_company_id: companyId } });
      analyticsTrackEvent("Payer Updated", "Payer", {
        projectId: record.project.id,
        paidForCompanyId: record.paidFor.id,
        paidForCompanyName: paidForCompany.name,
        payingCompanyId: companyId,
        payingCompanyName: payingCompanyName,
      });
      notify("Updated");
      refresh();
      setOpen(false);
    } catch (e) {
      notify(e.toString());
    }
  };

  if(!loaded) return null;

  return (
    <>
      <Button label="Update Payer" onClick={handleClick} />
      <Dialog open={open} onClose={handleDialogClose} fullWidth maxWidth="md">
        <DialogTitle>Update Payer</DialogTitle>
        <DialogContent>
          <Form
            onSubmit={handleEnable}
            render={({ handleSubmit }) => (
              <>
                <ReferenceInput
                  perPage={200}
                  source="companiesIds"
                  reference="Company"
                  resource="Company"
                  filterToQuery={companySearch}
                >
                  <AutocompleteInput  optionText="name"  onSelect={c => setCompany(c)}/>
                </ReferenceInput>
                <Button label="Set As Payer" onClick={handleSubmit} />
              </>
            )}
          ></Form>
        </DialogContent>
      </Dialog>
    </>
  );
};

const CompanyProjectPayerShowActions = ({ basePath, data, record }) => (
  <TopToolbar>
    <UpdatePayer basePath={basePath} record={data} />
  </TopToolbar>
);

export const CompanyProjectPayerShow = (props) => {
  return (
    <Show title="Payer Information" {...props} actions={<CompanyProjectPayerShowActions />}>
      <TabbedShowLayout syncWithLocation={false}>
        <Tab label="Summary">
          <TextField source="id" />
          <TextField source="title" />
          <ReferenceField label="Project" source="project.id" reference='Project' sortable={false} link="show">
            <TextField source="name"/>
          </ReferenceField>
          <ReferenceField label="Payer" reference="Company" source="payer.id" link="show" sortable={false}>
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField  label="Paid for" reference="Company" source="paidFor.id" link="show" sortable={false}>
            <TextField source="name" />
          </ReferenceField>
          <TextField source="created_at"/>
          <TextField source="updated_at"/>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};
